import { Directive, ElementRef, HostListener } from '@angular/core';
import { FormGroupDirective, NgForm } from '@angular/forms';
import { fromEvent } from 'rxjs';
import { debounceTime, take } from 'rxjs/operators';

@Directive({
  standalone: true,
  selector: '[appInvalidControlScroll]',
})
export class InvalidControlScrollDirective {
  private get containerEl(): HTMLElement {
    return window as any;
  }

  constructor(
    private el: ElementRef,
    private formGroupDir: NgForm
  ) {}

  @HostListener('ngSubmit') onSubmit() {
    if (this.formGroupDir.control.invalid) {
      this.scrollToFirstInvalidControl();
    }
  }

  private scrollToFirstInvalidControl() {
    const firstInvalidControl: any = this.el.nativeElement.querySelector('.ng-invalid');

    this.containerEl.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: 'smooth',
    });

    fromEvent(this.containerEl, 'scroll')
      .pipe(debounceTime(100), take(1))
      .subscribe(() => {
        console.log('scroll');
        firstInvalidControl.focus();
      });
  }

  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 70;
    const controlElTop = controlEl.getBoundingClientRect().top;

    const absoluteControlElTop = controlElTop + window.scrollY;

    return absoluteControlElTop - labelOffset;
  }
}
